import React from "react";
import { STORAGE } from "../../constants";
import atticusLogo from "../../assets/Atticus_Logo.svg";
import chromeLogo from "../../assets/logo-google-chrome.png";
import safariLogo from "../../assets/logo-apple-safari.png";
import firefoxLogo from "../../assets/logo-mozilla-firefox.png";
import edgeLogo from "../../assets/logo-microsoft-edge.png";

const browserLinkStyle = {
  textDecoration: "none",
  color: "black",
} as const;

export const UpgradeBrowser = (): JSX.Element => {
  return (
    <div
      style={{
        width: "100%",
        margin: "20px auto",
      }}
    >
      <div
        style={{
          textAlign: "center",
          fontFamily: "Montserrat",
          margin: "20px auto",
          maxWidth: 600,
          borderRadius: 8,
          border: "none",
          boxShadow:
            "0px 5px 5px -3px rgba(116, 135, 164, 0.16), 0px 8px 10px 1px rgba(116, 135, 164, 0.11), 0px 3px 14px 2px rgba(116, 135, 164, 0.1)",
          padding: 20,
          color: "#",
        }}
      >
        <div
          style={{
            backgroundColor: "rgba(242, 242, 255, 1)",
            borderRadius: "8px 8px 0 0",
            padding: "30px 40px 20px",
            margin: -20,
          }}
        >
          <img src={atticusLogo} alt="Atticus" />
          <h1
            style={{
              fontSize: 24,
              lineHeight: "32px",
            }}
          >
            Oops! It looks like your web browser needs to be updated
          </h1>
        </div>
        <p
          style={{
            marginTop: 40,
          }}
        >
          Please consider updating to, downloading, or using one of the
          following web browsers:
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            margin: "40px 0",
          }}
        >
          <a href="https://www.google.com/chrome/" style={browserLinkStyle}>
            <img src={chromeLogo} alt="Google Chrome" />
            <br />
            Google Chrome
          </a>
          <a
            href="https://support.apple.com/downloads/safari"
            style={browserLinkStyle}
          >
            <img src={safariLogo} alt="Apple Safari" />
            <br />
            Apple Safari
          </a>
          <a
            href="https://www.mozilla.org/en-US/firefox/new/"
            style={browserLinkStyle}
          >
            <img src={firefoxLogo} alt="Mozilla Firefox" />
            <br />
            Mozilla Firefox
          </a>
          <a
            href="https://www.microsoft.com/en-us/edge"
            style={browserLinkStyle}
          >
            <img src={edgeLogo} alt="Microsoft Edge" />
            <br />
            Microsoft Edge
          </a>
        </div>
        <p>
          <button
            style={{
              cursor: "pointer",
              color: "rgba(1, 217, 198, 1)",
              border: "none",
              background: "none",
            }}
            onClick={() => {
              window.localStorage.setItem(STORAGE.browserBypass, "true");
              window.location.reload();
            }}
          >
            Proceed anyway
          </button>
        </p>
      </div>
    </div>
  );
};
